import React from "react";

export const getLeadStatusClass = (status) => {
  const statusClassMap = {
    "Not Logged In": "status-yellow",
    "Logged In": "status-blue",
    "Terms & Conditions Viewed": "status-purple",
    "Agreed to Terms & Conditions": "status-orange",
    "Educational Content Viewed": "status-purple",
    "Paycheck Illustration Viewed": "status-purple",
    "Enrollment Question Viewed": "status-purple",
    "Enrollment Elected": "status-green",
    "Enrollment E-sign Viewed": "status-purple",
    "Enrollment E-sign Completed": "status-green",
    "Enrollment Declined": "status-red",
    "Welcome Viewed": "status-purple",
  };

  return statusClassMap[status] || "status-purple";
};

/** Lead status filter options for Welcome Onboarding / Compliance */
export const WELCOME_COMPLIANCE_LEAD_STATUSES = [
  "Not Logged In",
  "Logged In",
];

export const LEAD_DETAILS_COLUMNS = [
  {
    title: "Lead Name",
    dataIndex: "name",
    key: "name",
    render: (text) => <span className="text-capitalize">{text}</span>,
  },
  {
    title: "Lead Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Lead Phone number",
    dataIndex: "phone",
    key: "phone",
  },
  {
    title: "Lead Status",
    dataIndex: "memberActionStatus",
    key: "memberActionStatus",
    render: (status) => (
      <span className={`lead-status-badge fs-16 ${getLeadStatusClass(status)}`}>
        {status}
      </span>
    ),
  },
];
